<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 w-100">
        <div class="d-flex align-items-center gap-2">
          <h6 class="modal-title">
            {{ contract?.name }}
          </h6>
          <ng-container *ngIf="contract?.status | contractStatus as status">
            <div class="badge badge-pill text-sm" [ngClass]="'badge-' + status.color">
              <i [ngClass]="status.icon"></i>
              {{ status.name }}
            </div>
            <ul class="dot-segments-list text-muted">
              <li>{{ contract?.status_at | epoch : 'date' }}</li>
              <li>{{ contract?.status_at | epoch : 'time' }}</li>
            </ul>
          </ng-container>
        </div>

        <div class="flex-fill"></div>

        <ng-template [ngTemplateOutlet]="actions"></ng-template>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>

    <ul class="nav drawer-right-navbar">
      <li [class.active]="currentTab === tabs.Details" i18n-matTooltip matTooltip="Details" matTooltipPosition="left">
        <a (click)="currentTab = tabs.Details">
          <i class="cs-icon cs-icon-file-alt"></i>
        </a>
      </li>
      <li [class.active]="currentTab === tabs.Options" i18n-matTooltip matTooltip="Options" matTooltipPosition="left">
        <a (click)="currentTab = tabs.Options">
          <i class="cs-icon cs-icon-cog"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <div class="panel-content">
        <div class="contract-file-wrapper">
          <app-pdf-preview [pdfUrl]="contract?.pdf_file_url" [reload]="isCompleted"></app-pdf-preview>
        </div>
        <div [ngSwitch]="currentTab" class="">
          <div class="contract-sidebar container-box" *ngSwitchCase="tabs.Details">
            <app-signer-status [contract]="contract"></app-signer-status>
            <app-contract-timeline [contract]="contract"></app-contract-timeline>
          </div>
          <div class="contract-sidebar container-box" *ngSwitchCase="tabs.Options">
            <app-contract-options [contract]="contract"></app-contract-options>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actions>
  <div dropdown class="dropdown">
    <button dropdownToggle class="btn btn-secondary-warning">
      <i class="cs-icon cs-icon-bolt"></i> <ng-container i18n>Actions</ng-container>
    </button>

    <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
      <li>
        <a
          i18n-matTooltip
          matTooltip="Edit the name of this document."
          matTooltipPosition="left"
          (click)="helperService.onRename(contract)"
        >
          <i class="far fa-edit fa-fw" aria-hidden="true"></i> <ng-container i18n>Rename</ng-container>
        </a>
      </li>
      <ng-container *ngIf="contract?.status === contractStatus.Pending">
        <li *ngIf="contract?.origin_pdf_file_url">
          <a
            i18n-matTooltip
            matTooltip="Update document with the latest data"
            matTooltipPosition="left"
            (click)="helperService.onSync(contract)"
          >
            <i class="far fa-sync-alt fa-fw" aria-hidden="true"></i> <ng-container i18n>Update Document</ng-container>
          </a>
        </li>
        <li>
          <a
            i18n-matTooltip
            matTooltip="Send this document to the signers again, using the latest email address saved in the guest details."
            matTooltipPosition="left"
            (click)="helperService.onResend(contract)"
          >
            <i class="far fa-paper-plane fa-fw" aria-hidden="true"></i> <ng-container i18n>Resend</ng-container>
          </a>
        </li>
        <li>
          <a (click)="helperService.onComplete(contract)">
            <i class="far fa-check fa-fw" aria-hidden="true"></i> <ng-container i18n>Mark as Completed</ng-container>
          </a>
        </li>
      </ng-container>
      <li *ngIf="contract?.status === contractStatus.Completed">
        <a
          i18n-matTooltip
          matTooltip="Share this document via email."
          matTooltipPosition="left"
          (click)="helperService.onShare(contract)"
        >
          <i class="far fa-share-all fa-fw" aria-hidden="true"></i> <ng-container i18n>Share</ng-container>
        </a>
      </li>
      <li *ngIf="contract?.status === contractStatus.Pending">
        <a
          i18n-matTooltip
          matTooltip="Cancel this document for all signers. Once canceled, the document can no longer be completed."
          matTooltipPosition="left"
          (click)="helperService.onCancel(contract)"
        >
          <i class="far fa-ban fa-fw" aria-hidden="true"></i> <ng-container i18n>Cancel</ng-container>
        </a>
      </li>
    </ul>
  </div>
  <a
    class="btn btn-secondary-primary"
    *ngIf="contract?.status === contractStatus.Completed"
    i18n-matTooltip
    matTooltip="Download this document as a PDF."
    (click)="helperService.onDownloadContract(contract)"
  >
    <i class="cs-icon cs-icon-download"></i> <ng-container i18n>Download</ng-container>
  </a>
</ng-template>
